"use client"

import { Share2 } from "lucide-react"
import { useQueryStates } from "nuqs"
import { storeProductsQueryParsers } from "@/components/e-commerce/store/query-params/client"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

interface StoreToolbarProps {
  shopUrl?: string | null
}

export const StoreToolbar = ({
  shopUrl,
}: StoreToolbarProps): React.ReactNode => {
  const [query, setQuery] = useQueryStates(storeProductsQueryParsers, {
    history: "replace",
    shallow: true,
  })

  const updateSearchParams = (patch: Partial<typeof query>) => {
    setQuery(patch)
  }

  return (
    <header className='rounded-xl border border-gray-200 bg-white p-4'>
      <form
        className='grid grid-cols-1 gap-3 md:grid-cols-[1fr_auto_auto_auto]'
        onSubmit={(event) => {
          event.preventDefault()
          updateSearchParams({ q: query.q.trim() })
        }}
      >
        <Input
          aria-label='Buscar produtos da loja'
          onChange={(event) => updateSearchParams({ q: event.target.value })}
          placeholder='Buscar produtos da loja'
          type='search'
          value={query.q}
        />

        <select
          aria-label='Ordenar por'
          className='h-9 rounded-md border border-input bg-transparent px-3 text-sm'
          onChange={(event) =>
            updateSearchParams({
              orderby: event.target.value as typeof query.orderby,
            })
          }
          value={query.orderby}
        >
          <option value='menu_order'>Mais relevantes</option>
          <option value='popularity'>Mais populares</option>
          <option value='date'>Mais recentes</option>
          <option value='rating'>Melhor avaliados</option>
          <option value='title'>Nome</option>
        </select>

        <select
          aria-label='Direcao da ordenacao'
          className='h-9 rounded-md border border-input bg-transparent px-3 text-sm'
          onChange={(event) =>
            updateSearchParams({
              order: event.target.value as typeof query.order,
            })
          }
          value={query.order}
        >
          <option value='asc'>Crescente</option>
          <option value='desc'>Decrescente</option>
        </select>

        <div className='flex items-center gap-2'>
          {shopUrl && (
            <Button asChild type='button' variant='default'>
              <a href={shopUrl} rel='noopener noreferrer' target='_blank'>
                <Share2 className='h-4 w-4' />
                Compartilhar
              </a>
            </Button>
          )}
        </div>
      </form>
    </header>
  )
}
